import axios from 'axios'
const getServerURL = require('./get-server-url').default

const Axios = axios.create({
  baseURL: getServerURL(),
  withCredentials: true
})

export default Axios